<template>
  <div :class="`sc-block ${type}`">
    <div class="sc-block__container">
      <control-header :contract="contract" :type="type" />
      <div class="sc-block__content" v-if="contract[type]">
        <scenario-select :contract="contract" :type="type" />
        <common-info
          style="margin-top: 8px;"
          :contract="contract"
          :type="type"
        />
        <stages-values
          style="margin-top: 24px;"
          :contract="contract"
          :type="type"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ControlHeader from './control-header'
import ScenarioSelect from './scenario-select'
import CommonInfo from './common-info'
import StagesValues from './stages-values'

export default {
  props: ['contract', 'type', 'name'],
  components: {
    ControlHeader,
    ScenarioSelect,
    CommonInfo,
    StagesValues
  }
}
</script>

<style lang="less">
.sc-block {
  &__content {
    margin-top: 16px;
  }
}
</style>
